import script from "./ContactContentYellow.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactContentYellow.vue?vue&type=script&setup=true&lang=js"

import "./ContactContentYellow.vue?vue&type=style&index=0&id=01d175f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d175f9"]])

export default __exports__